import styled from "styled-components";

export const TextTyper = styled.span`
  font-weight: 700;
`;
